import { IFile } from '@shared';
import { createReducer, on } from '@ngrx/store';
import { deleteFileSuccess, getFilesSuccess, uploadFileSuccess } from '../actions';

const initialState: IFile[] = [];

export const filesReducer = createReducer(
  initialState,
  on(getFilesSuccess, (state, { files }) => files),
  on(uploadFileSuccess, (state, { file }) => [...state, file]),
  on(deleteFileSuccess, (state, { id }) => state.filter((file: IFile) => file.id !== id)),
);
